/** @jsx jsx */
import { h, Fragment, Component } from "preact";
import { observer } from "mobx-react";
import { useMemo, useState, useEffect } from 'preact/hooks';
import { jsx, css } from '@emotion/react';

import classnames from 'classnames';

import { MediaQuery } from '../Helpers/MediaQuery'
import { filters } from '@searchspring/snap-toolbox';

import {
  ThemeProvider,
  defaultTheme,
  FilterSummary,
  Facet,
  FacetSlider,
  FacetGridOptions,
  FacetPaletteOptions,
  FacetListOptions,
  FacetHierarchyOptions,
  StoreProvider,
  withStore,
  withTheme,
  withController,
  ControllerProvider,
  Icon,
} from '@searchspring/snap-preact-components';

import './sidebar.css'

@observer
export class Sidebar extends Component {
  render() {
    const store = this.props.controller.store;

    return (
      <ThemeProvider theme={defaultTheme}>
        <ControllerProvider controller={this.props.controller}>
          <StoreProvider store={store}>
            <SidebarContents />
          </StoreProvider>
        </ControllerProvider>
      </ThemeProvider>
    );
  }
}

@withController
@withStore
@observer
export class SidebarContents extends Component {
  render() {
    const {
      filters,
      facets,
    } = this.props.store;

    const leftColumnLayout = this.props.leftColumnLayout;
    let displayIconFilters = ["mfield_cql_arch_height", "mfield_cql_insole_thickness", "mfield_cql_underfoot_cushioning"];

    //Check if French
    if(window.Shopify.locale === "fr") {
      displayIconFilters = ["mfield_french_arch_height", "mfield_french_insole_thickness", "mfield_french_underfoot_cushioning"];
    }
  
    const isTierOne =  window.location.pathname.indexOf('collections/all') > -1;

    //For tags, trim out french prefix
    //Mobile active filters
    filters.forEach((filter, index) => {
      if(filter.label.includes("french")) {
        filters[index].value.label = filters[index].value.label.replace("french__", "");
      }
      
      filters[index].value.label = filters[index].value.label.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    });

    return (
      <div class={ leftColumnLayout ? "ss-sidebar-container-left-column" : "ss-sidebar-container"}>
        <FilterSummary filters={filters} controller={this.props.controller} />

        <MediaQuery query="(min-width: 990px)">
          <SidebarHeadings />
        </MediaQuery>

        <div className='ss__facets'>
          {facets.map((facet, index) => {
            const displayIcon = displayIconFilters.indexOf(facet.field) > -1;
            let hideActivity = !isTierOne && facet.label.toLowerCase() === "activity";

            //TODO: Hook this "Activity" check up to a metafield or theme setting instead of hard code.
            if(window.Shopify.locale === "fr") {
              hideActivity = !isTierOne && facet.label.toLowerCase() === "activité";
            }

            return facet.display === 'none' || hideActivity ? null : (
              <>
                <CustomFacet displayIcon={displayIcon} facet={facet} disableOverflow index={index}/>
                <hr className="facet__sidebar-separator"/>
              </>
            );
          })}
        </div>
      </div>
    );
  }
}
/*
Shopify.page_title -> window.Resources.searchspring.toolbar.sidebarHeadingFilter
    window.Resources.searchspring.toolbar.collectionTagline -> collection.metafields.cql.collection_tagline_text
    window.Resources.searchspring.toolbar.collectionTaglineLinkText -> collection.metafields.cql.collection_tagline_link_text
    window.Resources.searchspring.toolbar.collectionTaglineLinkUrl -> collection.metafields.cql.collection_tagline_link_url
*/
export const SidebarHeadings = () => {
  return (
    <>
      {!Shopify.page_title &&
      <div class="ss-sidebar-heading">
        {window.Resources.searchspring.toolbar.sidebarHeadingBlogPosts &&
          <h1 className="headline headline-small ss-sidebar-heading__blog">{ window.Resources.searchspring.toolbar.sidebarHeadingBlogPosts }</h1>
        }
        <p className="headline headline-small ss-sidebar-heading__search">{ window.Resources.searchspring.toolbar.sidebarHeadingFilter }</p>
      </div>
      }
      {Shopify.page_title &&
        <div class="ss-sidebar-heading">
          {window.Shopify.locale === "fr" ? (
            <>
              {window.Resources.searchspring.toolbar.collectionHeaderName &&
                <h1 className="headline headline-small ss-sidebar-heading__collection">{ window.Resources.searchspring.toolbar.collectionHeaderName }</h1>
              }
              {window.Resources.searchspring.toolbar.frenchCollectionTagline != "" &&
                <div className="body-small">
                  {window.Resources.searchspring.toolbar.frenchCollectionTagline}
                </div>
              }
            
              {window.Resources.searchspring.toolbar.frenchCollectionTaglineLinkText != "" &&
                <a href={window.Resources.searchspring.toolbar.frenchCollectionTaglineLinkUrl} className="button button--link-1" target="_blank">
                  {window.Resources.searchspring.toolbar.frenchCollectionTaglineLinkText}
                  <svg class="icon icon-arrow" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="formkit:arrowright" clip-path="url(#clip0_6988_4363)">
                      <path id="Vector" d="M12.5 5.5H3.5C3.22 5.5 3 5.28 3 5C3 4.72 3.22 4.5 3.5 4.5H12.5C12.78 4.5 13 4.72 13 5C13 5.28 12.78 5.5 12.5 5.5Z" fill="#0D0D0D"/>
                      <path id="Vector_2" d="M10 8.99998C9.93442 9.00078 9.86941 8.98785 9.80913 8.96201C9.74885 8.93618 9.69465 8.89802 9.65 8.84998C9.45 8.64998 9.45 8.33998 9.65 8.13998L12.8 4.98998L9.65 1.83998C9.45 1.63998 9.45 1.32998 9.65 1.12998C9.85 0.92998 10.16 0.92998 10.36 1.12998L13.86 4.62998C14.06 4.82998 14.06 5.13998 13.86 5.33998L10.36 8.83998C10.26 8.93998 10.13 8.98998 10.01 8.98998L10 8.99998Z" fill="#0D0D0D"/>
                    </g>
                    <defs>
                      <clipPath id="clip0_6988_4363">
                        <rect width="16" height="9" fill="white" transform="translate(0 0.5)"/>
                      </clipPath>
                    </defs>
                  </svg>
                </a>
              }
            </>
            ) : (
            <>
              <h1 className="headline headline-small ss-sidebar-heading__collection">{ Shopify.page_title }</h1>
              {window.Resources.searchspring.toolbar.collectionTagline != "" &&
                <div className="body-small">
                  {window.Resources.searchspring.toolbar.collectionTagline}
                </div>
              }
              
              {window.Resources.searchspring.toolbar.collectionTaglineLinkText != "" &&
                <a href={window.Resources.searchspring.toolbar.collectionTaglineLinkUrl} className="button button--link-1" target="_blank">
                  {window.Resources.searchspring.toolbar.collectionTaglineLinkText}
                  <svg class="icon icon-arrow" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="formkit:arrowright" clip-path="url(#clip0_6988_4363)">
                      <path id="Vector" d="M12.5 5.5H3.5C3.22 5.5 3 5.28 3 5C3 4.72 3.22 4.5 3.5 4.5H12.5C12.78 4.5 13 4.72 13 5C13 5.28 12.78 5.5 12.5 5.5Z" fill="#0D0D0D"/>
                      <path id="Vector_2" d="M10 8.99998C9.93442 9.00078 9.86941 8.98785 9.80913 8.96201C9.74885 8.93618 9.69465 8.89802 9.65 8.84998C9.45 8.64998 9.45 8.33998 9.65 8.13998L12.8 4.98998L9.65 1.83998C9.45 1.63998 9.45 1.32998 9.65 1.12998C9.85 0.92998 10.16 0.92998 10.36 1.12998L13.86 4.62998C14.06 4.82998 14.06 5.13998 13.86 5.33998L10.36 8.83998C10.26 8.93998 10.13 8.98998 10.01 8.98998L10 8.99998Z" fill="#0D0D0D"/>
                    </g>
                    <defs>
                      <clipPath id="clip0_6988_4363">
                        <rect width="16" height="9" fill="white" transform="translate(0 0.5)"/>
                      </clipPath>
                    </defs>
                  </svg>
                </a>
              }
            </>
          )}
        </div>
      }
    </>
  )
}

const Tooltip = function(props) {
  const [open, setOpen] = useState(false);

  function openTooltip(e) {
    e.stopPropagation();
    setOpen(!open);
    document.addEventListener("click", function closeTooltip() {
      document.removeEventListener('click', closeTooltip);
      setOpen(false);
    });
  }

  return (
    <span onClick={openTooltip} className="filter-tooltip">
      {open && <span class="tooltip-info" onClick={(e) => e.stopPropagation()}>{props.tooltip}</span>}
    </span>
  );
};

export const CustomFacet = withTheme(
  withController(
    observer(({ theme, controller, facet, index, displayIcon }) => {
      const store = controller.store;
      const { custom, facets } = store;
      if (facet.display == 'none') {
        return null;
      }

      //Facet overflow limit (i.e, Show More)
      if (facet.overflow) {
        if (facet.display == 'palette') {
          facet.overflow.setLimit(30);
        } else {
          facet.overflow.setLimit(7);
        }
      }

      let values =  facet?.refinedValues;
      let tagValues = null;

      //Special tags logic
      //Tags field is 1 stream for both languages on CA, and that can't be changed due to Shopify structure
      //So we must split up tags based on a language identifier.
      if(facet?.field == "tags") {
        //If we are on the frech store locale
        if(window.Shopify.locale === "fr") {
          //Filter out any english tags
          tagValues = facet.values.filter(value => value.value.toLowerCase().includes("french_"));

          tagValues.forEach((value, index) => {
            if(value.label.toLowerCase().includes("french")) {
              //Remove french prefix from the display label
              tagValues[index].label = tagValues[index].label.replace("french__", "");
            }
          });
        }
        else {
          tagValues = facet.values.filter(value => !value.value.includes("french_"));
        }
      }

      if (facet.display == 'slider') {
        values = '';
      } 

      //Prevents Active filters from going to the top of the list
      const facetListValues = [...values].sort((a,b)=> {
        if (a.value < b.value) return -1;
        if (a.value > b.value) return 1;
        return 0;
      });

      if (facet.field == "type") {
        facetListValues.map( i => i.label = i.label.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '))
      }

      // check if facet should show scroll
      const scroll = facet.overflow && facet.overflow.enabled && !facet.overflow.remaining ? true : false;

      // scroll to top of facet list on click
      useEffect(() => {
        document.querySelectorAll('.ss__facet__options a').forEach( opt => opt.addEventListener('click', () => { window.scrollTo({ top: 350, behavior: 'smooth' })}))
      }, [facetListValues]);

      const isSizes = facet.label === 'Size' ? true : false;
      const columns = isSizes ? 5 : 4;
      const className = `ss__facet-grid-options`;
      const labelClass  = facet.label;
      const tooltip = window.Resources.searchspring.filter_tooltips[facet.label];
      
      return (
        facet && (
          <div
            id={`ss__facet--${facet.field}`}
            className={classnames(`ss__facet ss__facet--${facet.field}`, {
              'ss__facet--collapsed': facet.collapsed,
              'ss__facet--expanded': !facet.collapsed,
              "display-icons": displayIcon
            })}
          >
            <div className={classnames(`ss__dropdown ss__facet__dropdown ${facet.collapsed ? '' : 'ss__dropdown--open'}`)}>
              <div class="ss__dropdown__button" role="button"
                  aria-expanded="true"
                  onClick={() => {
                      facet.toggleCollapse();
                  }}>
                <div class="ss__facet__header" role="heading" aria-level="2" aria-label={`currently ${facet.collapsed ? 'collapsed' : 'open'} ${facet.label} facet dropdown`} ssa11y="true" tabindex="0">
                  <div class="ss__facet___header--label">{facet.label}</div>
                  {tooltip && <Tooltip tooltip={tooltip} />}
                  {<Icon icon={facet?.collapsed ? "angle-down" : "angle-up"} />}
                </div>
                  
              </div>
               
              <div class="ss__dropdown__content">
                <div className={classnames(`ss__custom-facet ss__facet__options ${facet.display == 'palette' ? `ss__facet-options-display ${labelClass}` : ''}`)}>
                  {!facet.field.includes("tags") &&
                    {
                      grid: <FacetGridOptions values={values} scroll={scroll} type={'facet'} columns={columns} className={className}/>,
                      palette: <CustomFacetPaletteOptions facet={facet} scroll={scroll} type={'facet'} showLabel={true} showMore={true} />,
                      hierarchy: <FacetHierarchyOptions values={values} />,
                      slider: <FacetSlider facet={facet} />,
                      list: <FacetListOptions values={values} scroll={scroll} />,
                    }[facet.display]
                  }
                  
                  {/* Tags get displayed separatley, due to potential of being in a different language */}
                  {facet.field.includes("tags") &&
                    <FacetListOptions values={tagValues} scroll={scroll} />
                  }
                </div>

                {facet.overflow && facet.overflow.enabled && (
                  <div class="ss__facet__show-more-less body-small" open={`${facet.overflow.remaining ? 'false' : 'true'}`} ssa11y="true" tabindex="0"
                  onClick={() => {
                    facet.overflow.toggle();
                  }}>
                    <span>{facet.overflow.remaining ?  window.Resources.searchspring.toolbar.show_more : window.Resources.searchspring.toolbar.show_less}</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        )
      )
    })
  )
);

const OptionsSlot = ({ facet, limit }) => {
  const { label } = facet;
  const labelClass  = facet.label;

  const optionHelper = useMemo(() => {
    const optionHelperJSONString = document.getElementById('optionHelpers')?.textContent;
    const optionHelpers = optionHelperJSONString ? JSON.parse(optionHelperJSONString) : {};
    return optionHelpers[label.toLowerCase()]?.valueHelper;
  }, [label]);

  const facetDisplay = useMemo(() => {
    switch (facet.display) {
      case 'grid': {
        const isSizes = facet.label === 'Size' ? true : false;
        const columns = isSizes ? 5 : 4;
        const className = `ss__facet-grid-options`;
        return <FacetGridOptions values={facet.values} columns={columns} className={className} />;
      }
      case 'palette':
        return <CustomFacetPaletteOptions facet={facet} />;
      case 'hierarchy':
        return <FacetHierarchyOptions values={facet.values} />;
      case 'slider':
        return <FacetSlider facet={facet} />;
      default:
        return <FacetListOptions values={facet.values} />;
    }
  }, [facet]);

  return (
    <>
      {facetDisplay && <div className={`ss__facet-options-display ${labelClass} body-small`}>{facetDisplay}</div>}
      {optionHelper && <OptionHelper html={optionHelper} />}
    </>
  );
};

const CustomFacetPaletteOptions = ({ facet }) => {
  const { values } = facet;
  const { field } = facet;
  const { label } = facet;
  let displayIconFilters = ["mfield_cql_arch_height", "mfield_cql_insole_thickness", "mfield_cql_underfoot_cushioning"];

  //Check if French
  if(window.Shopify.locale === "fr") {
    displayIconFilters = ["mfield_french_arch_height", "mfield_french_insole_thickness", "mfield_french_underfoot_cushioning"];
  }

  //If special display icon is true, use SVG
  const extension = displayIconFilters.indexOf(facet.field) > -1 ? ".svg" : ".png";

  const shopifyFileURL = window.Resources.searchspring.shopifyURLs.fileURL.split('/placeholder')[0];
  let columns = label.includes('olor') ? 4 : 3;

  if(window.Shopify.locale === "fr") {
    columns = label.includes("ouleur") ? 4 : 3;
  }

  const transformedValues = useMemo(() => {
    return values.filter(v => v.label);
  }, [values]);

  const facetCss = useMemo(() => {
    const styles = {};

    transformedValues.forEach(v => {
      let filterLabel = v.label.replaceAll(' ', '-').toLowerCase();
      let filterImage = "";

      //Hacky fix for cached svg in shopify admin
      if (field == "mfield_cql_arch_height" && filterLabel == "medium") {
        filterImage = shopifyFileURL + "/" + field + "--" + "medium" + extension;
      }
      else {
        filterImage = shopifyFileURL + "/" + field + "__" + filterLabel.replaceAll('/', '-').normalize("NFKD").replace(/[\u0300-\u036f]/g, '') + extension;
      }

      let background = `url("${filterImage}")`;

      styles[`& .ss__facet-palette-options__option__palette--${filters.handleize(filterLabel)}`] = {
        display: 'block',
        background: background,
      };
    });

    return [css(styles)];
  }, [transformedValues]);

  return <FacetPaletteOptions css={facetCss} values={transformedValues} columns={columns} gapSize='0px' />;
};
